import React from 'react';
import Text from '@text';
import { useTranslation } from 'react-i18next';
import IconContact from '@assets/ERDE_Icon_Kontakt.png';
import FooterComponents from '@shared/footer/footer.components';
import { makeRecallButtonData } from '../../../network/services/get-form-fields/get-form-fields.service';
import { FormType } from '../../../types/form.types';
import { PORTAL_TYPE } from '../../../types/app.types';
import ContactFieldsComponents from '../../contact-form/contact-fields/contact-fields.components';

interface FooterProps {
  type: FormType;
  portalType: PORTAL_TYPE | undefined;
}

export interface ButtonInterface {
  backgroundColor: 'GRAY' | 'WHITE';
  showButton: boolean;
  url: string;
}

const {
  Container,
  PhoneContainer,
  ContactIcon,
  StyledText,
  Header
} = FooterComponents;
const { SubmitButton: ContactButton } = ContactFieldsComponents;

const Footer: React.FunctionComponent<FooterProps> = ({ type, portalType }) => {
  const { t } = useTranslation();
  const onClickHandler = (): void => {
    window.location.href = makeRecallButtonData().url;
  };
  const phone = t([
    `footer.${type}.phoneNumber`,
    `footer.${portalType}.phoneNumber`,
    'footer.phoneNumber'
  ]);
  return (
    <Container bgColor={makeRecallButtonData()?.backgroundColor ?? 'GRAY'}>
      <ContactIcon src={IconContact} alt="contact" />
      <Header
        className="ucf-paragraph"
        tParams={{
          tKey: [
            `footer.${type}.header`,
            `footer.${portalType}.header`,
            'footer.header'
          ]
        }}
      />
      <StyledText
        className="ucf-paragraph"
        tParams={{
          tKey: [
            `footer.${type}.openingHours`,
            `footer.${portalType}.openingHours`,
            'footer.openingHours'
          ]
        }}
      />
      <PhoneContainer>
        <StyledText
          className="ucf-paragraph"
          tParams={{
            tKey: [
              `footer.${type}.phone`,
              `footer.${portalType}.phone`,
              'footer.phone'
            ]
          }}
        />
        <a
          href={`tel:${phone}`}
          rel="contact us"
          aria-label={phone}
          className="ucf-link">
          <StyledText
            className="ucf-paragraph"
            tParams={{
              tKey: [
                `footer.${type}.phoneNumber`,
                `footer.${portalType}.phoneNumber`,
                'footer.phoneNumber'
              ]
            }}
          />
        </a>
      </PhoneContainer>
      {makeRecallButtonData()?.showButton && (
        <StyledText
          className="ucf-paragraph"
          tParams={{
            tKey: [
              `footer.${type}.desc`,
              `footer.${portalType}.desc`,
              'footer.desc'
            ]
          }}
        />
      )}
      {makeRecallButtonData()?.showButton && (
        <ContactButton onClick={onClickHandler}>
          <Text
            className="ucf-paragraph"
            tParams={{
              tKey: [
                `footer.${type}.calendlyButton`,
                `footer.${portalType}.calendlyButton`,
                'footer.calendlyButton'
              ]
            }}
          />
        </ContactButton>
      )}
    </Container>
  );
};

export default Footer;
